module.exports = __webpack_public_path__ + "static/media/logo.3c4bbe9f.png";